export * from "-!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./BigSlider.vue?vue&type=template&id=253f42f1&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/BigSlider.vue?vue&type=template&id=253f42f1&scoped=true&
// module id = 229
// module chunks = 0